import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  MobileNavLinksComponent,
  NavigationUIMenuKeys,
  PrimaryNavActionEvent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AdobeDataLayerService,
  HEADER_TOP_MENU
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { WidgetNavigationLinksFacadeService } from '../../../data-access/facades/widget-navigation-links/widget-navigation-links-facade.service';
@Component({
  selector: 'idp-widget-navigation-links',
  standalone: true,
  imports: [CommonModule, MobileNavLinksComponent],
  templateUrl: './widget-navigation-links.component.html',
  styleUrls: ['./widget-navigation-links.component.scss']
})
export class WidgetNavigationLinksComponent implements OnInit {
  @Input() selectedNav = 'book';
  @Input() isMenuOpen = false;
  @Input() isMobile = false;
  @Input() isAlertAdvisory = false;
  @Input() isBusiness = false;
  @Input() collapsedHeader = false;
  @Input() viewSearchOptionExpanded = false;
  @Output() widgetNavActionEvent = new EventEmitter<PrimaryNavActionEvent>();
  @Output() mobileWidgetNavClick = new EventEmitter<boolean>();
  adobeAnalytics = inject(AdobeDataLayerService);
  facade = inject(WidgetNavigationLinksFacadeService);

  ngOnInit(): void {
    this.facade.init();
  }

  emitAdobeAnalytics(e: { id: NavigationUIMenuKeys; label?: string }): void {
    const menus: Record<
      NavigationUIMenuKeys,
      (typeof HEADER_TOP_MENU)[keyof typeof HEADER_TOP_MENU]
    > = {
      book: HEADER_TOP_MENU.BOOK,
      check_in: HEADER_TOP_MENU.CHECK_IN,
      my_trips: HEADER_TOP_MENU.MY_TRIPS,
      flightstatus: HEADER_TOP_MENU.FLIGHT_STATUS,
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'sky-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    const id = e?.label?.toLowerCase()?.replace('?', '') || e.id;
    this.adobeAnalytics.updateAnalytics(id, menus[e?.id]);
  }

  onWidgetNavActionEvent(event: PrimaryNavActionEvent): void {
    const hasAdvanceSearch = !!document.querySelector('idp-advance-search');
    if (hasAdvanceSearch && event.id === 'book') {
      window.location.reload();
    } else {
      this.widgetNavActionEvent.emit(event);
    }
  }
}
